/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * Module containing Licensing services and components.
 * @preferred
 * @module LicensingModule
 */

import angular from 'angular';

import {
    LicensingService,
} from '.';

const licensingModule = angular.module('avi/licensing');

const services = [
    {
        service: LicensingService,
        name: 'licensingService',
    },
];

services.forEach(({ name, service }) => licensingModule.service(name, service));
